// extracted by mini-css-extract-plugin
module.exports = {"container_administratif":"administratif_container_administratif__2PkyZ","title_administratif":"administratif_title_administratif__IJrA-"};